var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinnhubUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 202,
    viewBox: "0 0 386 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 101C0 45.2192 45.2192 0 101 0H386V202H101C45.2192 202 0 156.781 0 101Z",
    fill: "#E6EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 101C11 45.2192 56.2192 0 112 0H386V202H112C56.2193 202 11 156.781 11 101Z",
    fill: "#F0F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.93 88.4103C231.284 71.2982 217.036 57.8721 199.5 57.8721C185.924 57.8721 174.306 65.9274 168.951 77.4858C167.334 76.9719 165.658 76.6233 163.876 76.6233C154.557 76.6233 147 84.1836 147 93.4992C147 95.3518 147.372 97.1034 147.923 98.7647C140.67 102.991 135.75 110.751 135.75 119.744C135.75 133.207 146.663 144.12 160.127 144.12V144.128H227.631V144.12C243.168 144.12 255.75 131.531 255.75 115.993C255.746 102.282 245.924 90.8931 232.93 88.4103ZM213.631 112.712L199.451 126.689C196.59 129.558 194.827 129.464 192.049 126.689L177.869 112.712C175.836 109.393 177.498 106.678 181.57 106.678H188.25V91.6319C188.25 89.5582 189.93 87.8742 192 87.8742H199.5C201.574 87.8742 203.25 89.5582 203.25 91.6319V106.678H209.922C213.995 106.678 215.667 109.393 213.631 112.712Z",
    fill: "#8D99DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinnhubUpload);
export default __webpack_public_path__ + "static/media/icon-finnhub-upload.088361ae85724318e4ad6a1ba36c0931.svg";
export { ForwardRef as ReactComponent };